<template>
    <ItemBase
        class="ItemMemoryiqPractice"
        :label="$t('label')"
        :title="$t('title')"
        :icon="icon"
        :progress="$attrs.progress"
        :locked="$attrs.locked"
        :pulse="$attrs.pulse"
        @click="open()"
    />
</template>

<translations>
  title: 'Improve<br> your memory'
  title_no: 'Få bedre<br> hukommelse'
  label: 'Practice'
  label_no: 'Praksis'
</translations>

<script>
import ItemBase from './ItemBase';
import icon from './icons/orange-memoryiq.svg';

export default {
    components: { ItemBase },
    created() {
        this.icon = icon;
    },
    methods: {
        open() {
            this.$router.push({
                name: 'MemoryIQView'
            });
        }
    }
};
</script>
